namespace GeniuzPOS.Purchase {
    export interface PoPurOrderAppRow {
        Id?: number;
        SysDocNo?: string;
        PurDocNo?: string;
        DocNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        SupplierId?: string;
        ShipId?: string;
        ShipName?: string;
        ShipLineAddress1?: string;
        ShipLineAddress2?: string;
        ShipLineAddress3?: string;
        ShipDate?: string;
        PayTermCode?: string;
        WhsId?: string;
        VatFg?: VatFgstatus;
        TotalAmt?: number;
        DiscText?: string;
        DiscAmt?: number;
        SalesVatTypes?: string;
        VatCode?: string;
        VatRate?: number;
        VatAmt?: number;
        PurOrderAmt?: number;
        Remark?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ApproveFg?: number;
        ApproveLv?: number;
        ApproveBy?: string;
        ApproveDate?: string;
        SendForAppfg?: number;
        CancelFg?: CancelFgstatus;
        RejectFg?: number;
        UseFg?: number;
        LastDateStatusChange?: string;
        Refuse?: string;
        DtList?: PoPurOrderDtRow[];
        AppList?: PoApprovalTranRow[];
        ShopId?: string;
        NetAmt?: number;
        NetExVat?: number;
        NetTotalInVat?: number;
        POTypeFg?: POTypeFg;
    }

    export namespace PoPurOrderAppRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.PoPurOrderApp';
        export const lookupKey = 'Purchase.PoPurOrderApp';

        export function getLookup(): Q.Lookup<PoPurOrderAppRow> {
            return Q.getLookup<PoPurOrderAppRow>('Purchase.PoPurOrderApp');
        }
        export const deletePermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:Modify';
        export const insertPermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:Modify';
        export const readPermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:View';
        export const updatePermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            PurDocNo = "PurDocNo",
            DocNo = "DocNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            SupplierId = "SupplierId",
            ShipId = "ShipId",
            ShipName = "ShipName",
            ShipLineAddress1 = "ShipLineAddress1",
            ShipLineAddress2 = "ShipLineAddress2",
            ShipLineAddress3 = "ShipLineAddress3",
            ShipDate = "ShipDate",
            PayTermCode = "PayTermCode",
            WhsId = "WhsId",
            VatFg = "VatFg",
            TotalAmt = "TotalAmt",
            DiscText = "DiscText",
            DiscAmt = "DiscAmt",
            SalesVatTypes = "SalesVatTypes",
            VatCode = "VatCode",
            VatRate = "VatRate",
            VatAmt = "VatAmt",
            PurOrderAmt = "PurOrderAmt",
            Remark = "Remark",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ApproveFg = "ApproveFg",
            ApproveLv = "ApproveLv",
            ApproveBy = "ApproveBy",
            ApproveDate = "ApproveDate",
            SendForAppfg = "SendForAppfg",
            CancelFg = "CancelFg",
            RejectFg = "RejectFg",
            UseFg = "UseFg",
            LastDateStatusChange = "LastDateStatusChange",
            Refuse = "Refuse",
            DtList = "DtList",
            AppList = "AppList",
            ShopId = "ShopId",
            NetAmt = "NetAmt",
            NetExVat = "NetExVat",
            NetTotalInVat = "NetTotalInVat",
            POTypeFg = "POTypeFg"
        }
    }
}
